import { render, staticRenderFns } from "./CoursePreviewItem.vue?vue&type=template&id=6229de78&scoped=true&"
import script from "./CoursePreviewItem.vue?vue&type=script&lang=js&"
export * from "./CoursePreviewItem.vue?vue&type=script&lang=js&"
import style0 from "./CoursePreviewItem.vue?vue&type=style&index=0&id=6229de78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6229de78",
  null
  
)

export default component.exports